export default "__VITE_ASSET__CSzm7aXj__"